<template>
  <div class="d-flex justify-center align-center flex-wrap">
    <v-menu
      ref="startDateMenu"
      :close-on-content-click="false"
      :return-value.sync="innerStart"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          append-icon="mdi-calendar"
          class="primary-button"
          style="text-transform: none"
          :disabled="disabled"
          readonly
          v-bind="attrs"
          v-on="on"
        >
          {{ formatMonth(innerStart) }}
        </v-btn>
      </template>
      <v-date-picker
        v-model="innerStart"
        type="month"
        locale="pt-br"
        no-title
        scrollable
        @change="onStartChange"
      />
    </v-menu>

    <span class="mx-2">{{ $t('até') }}</span>

    <v-menu
      ref="endDateMenu"
      :close-on-content-click="false"
      :return-value.sync="innerEnd"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          append-icon="mdi-calendar"
          class="primary-button"
          style="text-transform: none"
          :disabled="disabled"
          readonly
          v-bind="attrs"
          v-on="on"
        >
          {{ formatMonth(innerEnd) }}
        </v-btn>
      </template>
      <v-date-picker
        v-model="innerEnd"
        type="month"
        locale="pt-br"
        no-title
        scrollable
        @change="onEndChange"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateRangePicker',

  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      innerStart: this.startDate,
      innerEnd: this.endDate,
    }
  },

  watch: {
    startDate(v) {
      this.innerStart = v
    },
    endDate(v) {
      this.innerEnd = v
    },
  },

  methods: {
    formatMonth(date) {
      if (!date) return ''
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    onStartChange() {
      this.$refs.startDateMenu.save(this.innerStart)
      this.$emit('update:startDate', this.innerStart)
      this.$emit('change', { startDate: this.innerStart, endDate: this.innerEnd })
    },

    onEndChange() {
      this.$refs.endDateMenu.save(this.innerEnd)
      this.$emit('update:endDate', this.innerEnd)
      this.$emit('change', { startDate: this.innerStart, endDate: this.innerEnd })
    },
  },
}
</script>
